<template>
  <div class="form-wrapper animated fadeIn">
    <h2 class="form-title"><i class="fas fa-user-plus"></i> Add Worker</h2>

    <form @submit.prevent="submitForm" class="form-body">

      <!-- Full Name -->
      <div class="form-group">
        <label>Full Name</label>
        <input v-model="worker.name" type="text" placeholder="Enter worker's full name" required />
      </div>

      <!-- First Name -->
      <div class="form-group">
        <label>First Name</label>
        <input v-model="worker.first_name" type="text" placeholder="First Name" />
      </div>

      <!-- Surname -->
      <div class="form-group">
        <label>Surname</label>
        <input v-model="worker.surname" type="text" placeholder="Surname" />
      </div>

      <!-- Last Name -->
      <div class="form-group">
        <label>Last Name</label>
        <input v-model="worker.last_name" type="text" placeholder="Last Name" />
      </div>

      <!-- Email -->
      <div class="form-group">
        <label>Email</label>
        <input v-model="worker.email" type="email" placeholder="example@email.com" />
      </div>

      <!-- Phone Number -->
      <div class="form-group">
        <label>Phone Number</label>
        <input v-model="worker.phone_number" type="text" placeholder="0700 123456" />
      </div>

      <!-- Secondary Telephone -->
      <div class="form-group">
        <label>Secondary Telephone</label>
        <input v-model="worker.secondary_telephone" type="text" placeholder="Optional" />
      </div>

      <!-- Address -->
      <div class="form-group">
        <label>Country</label>
        <input v-model="worker.country" type="text" placeholder="Country" />
      </div>

      <div class="form-group">
        <label>Address 1</label>
        <input v-model="worker.address_1" type="text" placeholder="Address line 1" />
      </div>

      <div class="form-group">
        <label>Address 2</label>
        <input v-model="worker.address_2" type="text" placeholder="Address line 2" />
      </div>

      <div class="form-group">
        <label>County</label>
        <input v-model="worker.county" type="text" placeholder="County" />
      </div>

      <div class="form-group">
        <label>City</label>
        <input v-model="worker.city" type="text" placeholder="City" />
      </div>

      <div class="form-group">
        <label>Postal Code</label>
        <input v-model="worker.postal_code" type="text" placeholder="Postal Code" />
      </div>

      <!-- Metadata -->
      <div class="form-group">
        <label>Location</label>
        <input v-model="worker.location" type="text" placeholder="Location" />
      </div>

      <div class="form-group">
        <label>Industry</label>
        <input v-model="worker.industry" type="text" placeholder="Industry" />
      </div>

      <div class="form-group">
        <label>Education</label>
        <input v-model="worker.education" type="text" placeholder="Education" />
      </div>

      <div class="form-group">
        <label>Area</label>
        <input v-model="worker.area" type="text" placeholder="Area" />
      </div>

      <!-- National ID -->
      <div class="form-group">
        <label>National ID Number</label>
        <input v-model="worker.national_id_number" type="text" placeholder="National ID" />
      </div>

      <!-- Profile -->
      <div class="form-group">
        <label>Profile Picture URL</label>
        <input v-model="worker.profile_picture" type="text" placeholder="URL to profile picture" />
      </div>

      <div class="form-group">
        <label>Avatar URL</label>
        <input v-model="worker.avatar" type="text" placeholder="URL to avatar" />
      </div>

      <!-- Status -->
      <div class="form-group">
        <label>Status</label>
        <select v-model="worker.active">
          <option :value="true">Active</option>
          <option :value="false">Inactive</option>
        </select>
      </div>

      <!-- Payment Method -->
      <div class="form-group">
        <label>Payment Method</label>
        <input v-model="worker.payment_method" type="text" placeholder="e.g., Bank, Mobile Money" />
      </div>

      <!-- Submit -->
      <button class="btn btn-gradient" type="submit" :disabled="loading">
        <span v-if="loading"><i class="fas fa-spinner fa-spin"></i> Saving...</span>
        <span v-else><i class="fas fa-save"></i> Save Worker</span>
      </button>

      <!-- Error -->
      <p v-if="error" class="error-text">{{ error }}</p>

    </form>
  </div>
</template>

<script>
export default {
  name: "AddWorkerComponent",

  data() {
    return {
      worker: {
        name: "",
        first_name: "",
        surname: "",
        last_name: "",
        email: "",
        phone_number: "",
        secondary_telephone: "",
        country: "",
        address_1: "",
        address_2: "",
        county: "",
        city: "",
        postal_code: "",
        location: "",
        industry: "",
        education: "",
        area: "",
        national_id_number: "",
        profile_picture: "",
        avatar: "",
        active: true,
        status: "",
        payment_method: "",
      },
      loading: false,
      error: null,
    };
  },

  methods: {
    async submitForm() {
      this.loading = true;
      this.error = null;

      const payload = { ...this.worker, role: "worker" };

      try {
        await this.$store.dispatch("workers/addWorker", payload);
        this.$router.push({ name: "Workers" });
      } catch (err) {
        this.error = err?.response?.data?.message || "Failed to save worker";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.form-wrapper {
  max-width: 650px;
  margin: auto;
  background: #fff;
  padding: 25px;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.form-title {
  font-size: 22px;
  margin-bottom: 20px;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 10px;
}

.form-group {
  margin-bottom: 18px;
}
.form-group label {
  font-weight: 600;
  margin-bottom: 6px;
  display: block;
}
.form-group input,
.form-group select {
  width: 100%;
  padding: 12px;
  border-radius: 10px;
  border: 1px solid #ddd;
  outline: none;
}
.btn-gradient {
  width: 100%;
  background: linear-gradient(90deg, #007bff, #6610f2);
  padding: 12px;
  color: #fff;
  border: none;
  font-size: 16px;
  border-radius: 10px;
  cursor: pointer;
}
.btn-gradient:disabled {
  opacity: 0.7;
}
.error-text {
  margin-top: 12px;
  color: #f00;
  font-size: 14px;
}
</style>
